import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DepartmentInfo } from '../types/types';

interface DepartmentsState {
  departments: DepartmentInfo[];
}

const initialState: DepartmentsState = {
  departments: [],
};

const departmentsSlice = createSlice({
  name: 'departments',
  initialState,
  reducers: {
    setDepartments(state, action: PayloadAction<DepartmentInfo[]>) {
      state.departments = action.payload;
    },

    addDepartment(state, action: PayloadAction<DepartmentInfo>) {
      state.departments.push(action.payload);
    },

    removeDepartment(state, action: PayloadAction<DepartmentInfo>) {
      state.departments = state.departments.filter(
        (department) => department.name !== action.payload.name,
      );
    },

    clearDepartments(state) {
      state.departments = [];
    },
  },
});

export const {
  setDepartments,
  addDepartment,
  removeDepartment,
  clearDepartments,
} = departmentsSlice.actions;
export default departmentsSlice.reducer;
